const resumeData = {
  intro: {
    title: 'Introduction',
    content: `
## PRATHVIRAJ SINGH
## Data Scientist | Machine Learning Engineer

### Contact Information
- **Phone**: +91 8887521358
- **Location**: Gurugram, Haryana, India
- **Email**: [theprathvirajz@gmail.com](mailto:theprathvirajz@gmail.com)
- **LinkedIn**: [linkedin.com/in/prathviraj-singh-160b2725a](https://www.linkedin.com/in/prathviraj-singh-160b2725a/)

### Professional Summary
Data Analyst and Data Scientist with experience in machine learning, data analytics, and business intelligence. Strong background in Python, SQL, and Power BI, delivering actionable insights through data‑driven solutions. Currently working at CODERCOPS and upskilling in blockchain and Web3 fundamentals to apply analytics to staking systems, gaming ecosystems, and reward‑based platforms.`,
  },

  workExperience: {
    title: 'Work Experience',
    content: `
### CODERCOPS — Data Analyst _(Jan 2025 – Present)_
- Analyze business and operational data to identify trends, patterns, and performance gaps.
- Build Power BI and Excel dashboards for KPI tracking and management reporting.
- Perform data cleaning, validation, and transformation using Python and SQL.
- Deliver actionable insights to improve efficiency and decision‑making.

### Sparks Foundation — Machine Learning Intern _(2023 – 2024)_
- Developed house price and stock price prediction models using machine learning.
- Built a business data visualization dashboard using Excel.
- Performed EDA and data preprocessing using Pandas and NumPy to improve data quality.
- Applied regression and forecasting techniques to support business insights.`,
  },

  education: {
    title: 'Education',
    content: `
### B.Tech in Computer Science Engineering _(2020 – 2024)_
**Institute of Engineering & Technology, Agra**

### Class XII (PCM) _(2018 – 2019)_
**Jagran Public School, Lucknow**`,
  },

  projects: {
    title: 'Projects',
    content: `
### DrowseGuard — Driver Drowsiness Detection
- Built a real-time driver drowsiness detection system using computer vision and Eye Aspect Ratio (EAR).
- Processed live webcam video to monitor eye movement and detect fatigue.
- Triggered instant visual and audio alerts to prevent drowsiness-related accidents.
<a href="https://driver-drowsiness-detection-gsjgfdg57enjklwvhgs2ta.streamlit.app/" class="project-button" target="_blank" rel="noopener noreferrer">Try DrowseGuard</a>

### Iris Flower Prediction — Regression Model
- Developed a machine learning model to classify iris flower species using Scikit-Learn.
- Performed data preprocessing and exploratory data analysis to improve model accuracy.
- Achieved high prediction accuracy using supervised learning techniques.

### Fruits & Vegetable Classification
- Built a deep learning image classification model using transfer learning.
- Trained the model on 120+ fruit and vegetable categories.
- Improved classification performance through data augmentation and fine-tuning.

### Object Image Recognition
- Developed a computer vision system to detect humans, vehicles, and everyday objects.
- Implemented object detection using OpenCV and NumPy.
- Processed images and video streams for real-time object recognition.

### Handwritten Digit Recognition 
- Built a deep learning model to recognize handwritten digits from image data.
- Preprocessed image datasets to improve model accuracy and consistency.
- Trained and evaluated the model using neural networks for digit classification.
`,
  },

  certifications: {
    title: 'Certifications',
    content: `

- Python — University of Michigan
- Machine Learning — Andrew Ng (Coursera)
- Machine Learning — Udemy
- Responsible AI — DeepLearning.AI 
- Introduction to Large Language Models — DeepLearning.AI 
- Transformer Models and BERT — DeepLearning.AI 
- Career Skills in Data Analytics — University of Michigan`,
  },

  skills: {
    title: 'Core Skills',
    content: `
* Python
* SQL
* Machine Learning
* Data Analysis
* Power BI
* MS Excel
* Pandas
* NumPy
* Scikit-learn
* Data Cleaning
* Exploratory Data Analysis (EDA)
* Regression
* Classification
* Deep Learning
* OpenCV
* Data Visualization`,
  },
};

export default resumeData;
